import {css} from "@panda/css";
import cn from "classnames";

import {Button} from "@pg-design/button-module";
import {CheckIcon} from "@pg-design/icons-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {getLeadButtonText} from "../../lead/utils/get_lead_button_text";

interface IProps {
    handleClick: () => void;
    shouldShowPrice: boolean;
    isProperty?: boolean;
    price?: number | null;
    infoPlacement?: "top" | "bottom";
    vendorId?: number;
}

export const ApplicationDefaultRender = (props: IProps) => {
    const {handleClick, infoPlacement = "bottom"} = props;

    const buttonText = getLeadButtonText({
        isPriceHidden: !props.shouldShowPrice,
        isProperty: props.isProperty,
        propertyPrice: props.price
    });

    const renderInfo = (className: string) => (
        <div className={cn(infoHolder, className)}>
            <Text variant="info_txt_2" className={css({mb: 1})} color={getThemeVariable("colors.gray.800")}>
                Na swój adres e-mail otrzymasz:
            </Text>

            {infoArray.map((text) => (
                <div key={text} className={infoPoint}>
                    <CheckIcon size="1.4" wrapperSize="1.4" />
                    <Text variant="info_txt_2">{text}</Text>
                </div>
            ))}
        </div>
    );

    return (
        <div className={mainSection}>
            {infoPlacement === "top" && renderInfo(infoMb)}
            <Button
                variant="filled_primary"
                type="button"
                size="medium"
                onClick={handleClick}
                className={css({width: "100%"})}
                dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON}
            >
                {buttonText}
            </Button>
            {infoPlacement === "bottom" && renderInfo(infoMt)}
        </div>
    );
};

const infoArray = ["Cenę miejsca garażowego", "Informacje dotyczące rezerwacji", "Harmonogram płatności"];

const mainSection = css({
    p: 1.5,
    backgroundColor: getThemeVariable("colors.gray.100"),
    borderRadius: 2
});

const infoHolder = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 1
});

const infoPoint = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 1
});

const infoMb = css({
    mb: 2
});

const infoMt = css({
    mt: 2
});
import {css} from "@panda/css";
import cn from "classnames";

import {Button} from "@pg-design/button-module";
import {CheckIcon} from "@pg-design/icons-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {getLeadButtonText} from "../../lead/utils/get_lead_button_text";

interface IProps {
    handleClick: () => void;
    shouldShowPrice: boolean;
    isProperty?: boolean;
    price?: number | null;
    infoPlacement?: "top" | "bottom";
    vendorId?: number;
}

export const ApplicationDefaultRender = (props: IProps) => {
    const {handleClick, infoPlacement = "bottom"} = props;

    const buttonText = getLeadButtonText({
        isPriceHidden: !props.shouldShowPrice,
        isProperty: props.isProperty,
        propertyPrice: props.price
    });

    const renderInfo = (className: string) => (
        <div className={cn(infoHolder, className)}>
            <Text variant="info_txt_2" className={css({mb: 1})} color={getThemeVariable("colors.gray.800")}>
                Na swój adres e-mail otrzymasz:
            </Text>

            {infoArray.map((text) => (
                <div key={text} className={infoPoint}>
                    <CheckIcon size="1.4" wrapperSize="1.4" />
                    <Text variant="info_txt_2">{text}</Text>
                </div>
            ))}
        </div>
    );

    return (
        <div className={mainSection}>
            {infoPlacement === "top" && renderInfo(infoMb)}
            <Button
                variant="filled_primary"
                type="button"
                size="medium"
                onClick={handleClick}
                className={css({width: "100%"})}
                dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON}
            >
                {buttonText}
            </Button>
            {infoPlacement === "bottom" && renderInfo(infoMt)}
        </div>
    );
};

const infoArray = ["Cenę miejsca garażowego", "Informacje dotyczące rezerwacji", "Harmonogram płatności"];

const mainSection = css({
    p: 1.5,
    backgroundColor: getThemeVariable("colors.gray.100"),
    borderRadius: 2
});

const infoHolder = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 1
});

const infoPoint = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 1
});

const infoMb = css({
    mb: 2
});

const infoMt = css({
    mt: 2
});
